module.exports = __webpack_public_path__ + "static/media/accept-friend.d286416a.svg";